<div class="main" [ngClass]="{ 'is-portrait': isPortraitDevice }">
    <div class="container" [ngClass]="{ 'is-portrait': isPortraitDevice }">
        <div class="headlines">
            <h1 *ngIf="!isPortraitDevice" class="headline-m">
                {{ additionalDataTitle | translate }}
            </h1>

            <p class="subtitle-m">
                {{ additionalDataSubtitle | translate }}
            </p>
        </div>
        <!--
        <div class="info">
            <div class="img"><i class="ri-information-line"></i></div>
            <div>
                <span class="text-informacion"> {{ infoYear | translate }}</span>
            </div>
        </div>
 -->
        <form class="form" [formGroup]="formGroup">
            <div class="form-row">
                <div class="info">
                    <div class="img"><i class="ri-information-line"></i></div>
                    <div>
                        <span class="text-informacion"> {{ infoYear | translate }}</span>
                    </div>
                </div>
            </div>
            <!-- year account -->
            <div class="form-row">
                <div class="form-field">
                    <p-dropdown
                        class="p-dropdown"
                        placeholder="{{ yearDrop | translate }}"
                        formControlName="year"
                        id="year"
                        class="p-dropdown"
                        [options]="selectedYears"
                        optionLabel="label"
                        inputId="float-label"
                        (onChange)="onChangeYear($event)"
                    >
                        <ng-template pTemplate="selectedItem">
                            <div class="flex align-items-center gap-2" *ngIf="selectedYear">
                                <span class="float-label-dropdown">{{ yearDrop | translate }}</span>

                                <div class="data-field-value-dropdown-item-selected">{{ selectedYear.code }}</div>
                            </div>
                        </ng-template>
                        <ng-template let-year pTemplate="item">
                            <div class="flex align-items-center gap-2">
                                <div class="selected-item-dropdown data-field-value-dropdown">
                                    {{ year.label }}
                                    <i *ngIf="year == selectedYear" class="ri-check-line class-icono-component"></i>
                                </div>
                            </div>
                        </ng-template>
                    </p-dropdown>
                </div>
            </div>
        </form>

        <div class="actions">
            <button
                *ngIf="!isPortraitDevice"
                pripple=""
                class="button-secondary button-next"
                type="button"
                [disabled]="backButtonDisabled"
                (click)="onClicButtonBack()"
            >
                <span class="ri-arrow-left-line p-button-icon p-button-icon-left ng-star-inserted"></span>
                <span class="p-button-label-right">{{ backButton | translate }}</span>
            </button>

            <button
                pripple=""
                class="button-primary button-next"
                type="button"
                [disabled]="continueButtonDisabled"
                (click)="onClicButtonContinue()"
                [ngClass]="{ 'is-portrait': isPortraitDevice }"
            >
                <span class="p-button-label-left">{{ continueButton | translate }}</span>
                <span class="ri-arrow-right-line p-button-icon p-button-icon-right ng-star-inserted"></span>
            </button>
        </div>
    </div>

    <div *ngIf="isPortraitDevice">
        <app-footer></app-footer>
    </div>

    <div class="chat-layer">
        <app-chat-layer></app-chat-layer>
    </div>
</div>
